
var regular = {
  // 手机号
  'mobile': {
    'pattern': /^1[0-9]{10}$/
  },
  // 电话号
  'phone': {
    'pattern': /^[0-9-_()（）]{3,18}$/
  },
  // 订单电话号
  'orderPhone': {
    'pattern': /^([0-9-]|[-_]){3,18}$/
  },
  // 账号
  'account': {
    'pattern': /^([a-zA-Z0-9]|[-_]){6,30}$/
  },
  // 密码
  'password': {
    'pattern': /^([a-zA-Z0-9]|[-_]){6,30}$/
  },
  // 用户名
  'userName': {
    'pattern': /^[A-Za-z\u4e00-\u9fa5]{1}[A-Za-z\u4e00-\u9fa5( ){0,}]{0,8}[A-Za-z\u4e00-\u9fa5]{1}$/
  },
  // 手机验证码
  'mobilecode': {
    'pattern': /^[0-9]{4,6}/
  },
  'companyName': {
    'pattern': /^[\u4E00-\u9FA5a-zA-Z0-9-_()（）]{2,30}$/
  },
  'cusName': {
    // 'pattern': '/^[\u4E00-\u9FA5a-zA-Z0-9-_\(\)]{1,30}$/'
  },

  "departmentName":{
    'pattern': /^.{2,30}$/u
  } ,
  'address': {
    'pattern': /^.{2,50}$/
  },
  'remark': {
    'pattern': '/^.{1,300}$/'
  },
  'troubleDescrible': {
    'pattern': '/^.{1,200}$/'
  },
  'price': {
    'pattern': /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
  },
  'partsName': {
    'pattern': '/^.{2,100}$/'
  },
  'partsModel': {
    'pattern': '/^.{2,20}$/'
  },
  'brandName': {
    'pattern': /^[A-Za-z0-9\u4e00-\u9fa5]{2,20}$/
  },
  // 故障名称
  'faultName': {
    'pattern': /^[A-Za-z0-9\u4e00-\u9fa5]{2,20}$/
  },
  // 简称
  'shortName': {
    'pattern': /^[A-Za-z0-9\u4e00-\u9fa5]{2,10}$/
  },
  // 价格
  'priceName': {
    // 'pattern': '/^[\u4E00-\u9FA5a-zA-Z0-9-_\(\)]/'
  },
  // 自定义标签名称
  'tagsName': {
    // 'pattern': /^[A-Za-z0-9\u4e00-\u9fa5\-\_\\\/]{1,5}$/
  },
  // 用户名
  'eventName': {
    'pattern': /^[A-Za-z0-9\u4e00-\u9fa5]{1,30}$/
  },
  'idcard': {
    'pattern': '/(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)/'
  },
  'money': {
    'pattern': '/((^[1-9]\\d*)|^0)(\\.\\d{0,2}){0,1}$/'
  },
  'serialNumber': {
    'pattern': '/^[^\u4E00-\u9FA5]{2,30}$/'
  },
  'specification': {
    'pattern': '/^.{2,30}$/'
  },
  'projectName': {
    'pattern': '/^.{1,30}$/'
  },
  'devideName': {
    'pattern': /^[^~`"'&]*$/
  }

};

export { regular };
